import { useEffect, useState, useCallback } from "react";

interface Sparkle {
  id: number;
  x: number;
  y: number;
  size: number;
  color: string;
}

const CursorSparkles = () => {
  const [sparkles, setSparkles] = useState<Sparkle[]>([]);

  const colors = [
    "hsl(var(--primary))",
    "hsl(var(--accent))",
    "hsl(200 100% 70%)",
    "hsl(45 100% 70%)",
  ];

  const createSparkle = useCallback((x: number, y: number) => {
    const sparkle: Sparkle = {
      id: Date.now() + Math.random(),
      x: x + (Math.random() - 0.5) * 20,
      y: y + (Math.random() - 0.5) * 20,
      size: Math.random() * 8 + 4,
      color: colors[Math.floor(Math.random() * colors.length)],
    };
    return sparkle;
  }, []);

  useEffect(() => {
    let lastTime = 0;
    const throttleMs = 50;

    const handleMouseMove = (e: MouseEvent) => {
      const now = Date.now();
      if (now - lastTime < throttleMs) return;
      lastTime = now;

      const newSparkle = createSparkle(e.clientX, e.clientY);
      setSparkles((prev) => [...prev.slice(-15), newSparkle]);
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [createSparkle]);

  useEffect(() => {
    const cleanup = setInterval(() => {
      setSparkles((prev) => prev.filter((s) => Date.now() - s.id < 600));
    }, 100);
    return () => clearInterval(cleanup);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-50" style={{ contain: 'strict' }}>
      {sparkles.map((sparkle) => (
        <div
          key={sparkle.id}
          className="absolute rounded-full animate-sparkle-fade"
          style={{
            transform: `translate3d(${sparkle.x}px, ${sparkle.y}px, 0)`,
            width: sparkle.size,
            height: sparkle.size,
            backgroundColor: sparkle.color,
            boxShadow: `0 0 ${sparkle.size * 2}px ${sparkle.color}`,
            willChange: 'transform, opacity',
          }}
        />
      ))}
    </div>
  );
};

export default CursorSparkles;
